var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import { is, Map } from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NeedAuthorization } from "../../Auth";
import ShowIf from "../../App/ShowIf";
import { t } from "../../I18N";
import UploadEntityStatus from "./UploadEntityStatus";
import ViewDocButton from "./ViewDocButton";
import { Icon } from "../../UI";

import { Item } from "../../Layout";
import helpers from "../../Documents/helpers";

export class Doc extends Component {
  shouldComponentUpdate(nextProps) {
    return (
      !is(this.props.doc, nextProps.doc) ||
      !is(this.props.targetReference, nextProps.targetReference) ||
      this.props.additionalText !== nextProps.additionalText ||
      this.props.active !== nextProps.active ||
      this.props.searchParams &&
      nextProps.searchParams &&
      this.props.searchParams.sort !== nextProps.searchParams.sort);

  }

  onClick(e) {
    if (this.props.onClick) {
      this.props.onClick(e, this.props.doc, this.props.active);
    }
  }

  getConnections(connections) {
    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      connections.map((connection, index) => /*#__PURE__*/
      _jsx("div", { className: "item-connection" }, index, /*#__PURE__*/
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "exchange-alt" }), /*#__PURE__*/
      _jsx("span", {}, void 0,
      t(connection.context, connection.label),
      connection.type === 'metadata' ? ` ${t('System', 'in')}...` : ''
      )
      ), /*#__PURE__*/
      _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
      _jsx(ShowIf, { if: connection.sourceType !== 'metadata' }, void 0, /*#__PURE__*/
      _jsx("button", {
        className: "btn btn-default btn-hover-danger btn-xs",
        onClick: (e) => this.deleteConnection(e, connection),
        type: "button" }, void 0, /*#__PURE__*/

      _jsx(Icon, { icon: "trash-alt" })
      )
      )
      )
      )
      )
      ));

  }

  deleteConnection(e, connection) {
    e.stopPropagation();
    const { _id, sourceType } = connection;
    this.props.deleteConnection({ _id, sourceType });
  }

  render() {
    const { className, additionalText, targetReference } = this.props;
    const doc = helpers.performantDocToJSWithoutRelations(this.props.doc);
    const { sharedId, file, processed } = doc;

    let itemConnections = null;
    if (doc.connections && doc.connections.length) {
      itemConnections = this.getConnections(doc.connections);
    }

    const buttons = /*#__PURE__*/
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx(ViewDocButton, {
      file: file,
      sharedId: sharedId,
      processed: processed,
      storeKey: this.props.storeKey,
      targetReference: targetReference }
    )
    );


    return /*#__PURE__*/(
      _jsx(Item, {
        onClick: this.onClick.bind(this),
        onSnippetClick: this.props.onSnippetClick,
        active: this.props.active,
        doc: this.props.doc,
        additionalText: additionalText,
        searchParams: this.props.searchParams,
        deleteConnection: this.props.deleteConnection,
        itemHeader: itemConnections,
        buttons: buttons,
        labels: /*#__PURE__*/_jsx(UploadEntityStatus, { doc: this.props.doc }),
        className: className }
      ));

  }
}

Doc.defaultProps = {
  targetReference: null
};















export function mapStateToProps(state, ownProps) {
  const active = ownProps.storeKey ?
  !!state[ownProps.storeKey].ui.
  get('selectedDocuments').
  find((doc) => doc.get('_id') === ownProps.doc.get('_id')) :
  false;
  return {
    active
  };
}

export default connect(mapStateToProps)(Doc);